export default class IninBase {
  constructor(cortona, canvas, xmlPath, external, colors) {
    this.cortona = cortona;
    this.canvas = canvas;
    this.xmlPath = xmlPath;
    this.external = external;
    this.colors = colors;

    this.xmlInteractivity = xmlPath;
    this.cortonaFrame = null;

    Object.defineProperty(this, 'cortona', { configurable: false }); //vue reactivity disable

    this.config = {
      baseUrl: 'spec/',
      src: this.xmlInteractivity,
      totalMemory: 256,
      // IllustrationType: 2
      // options: {
      //   IllustrationType: "2",
      //   UseSVGFilesOnly: true
      // }
    };
    this.drawing = {
      element: this.canvas,
      features:
        // this.cortona.app.ENABLE_NAVIGATION_FIT_TO_OBJECT |
        // this.cortona.app.DRAWING_HOTSPOT_HIGHLIGHT_SOLID |
        this.cortona.app.ENABLE_AUTO_SWITCHING_DISPLAY_MODE |
        this.cortona.app.DISABLE_DOCUMENT_INTERACTIVITY |
        this.cortona.app.TRANSPARENT_BACKGROUND,
    };
    this.loadEngine();
  }

  emit(name, value, asAction = false) {
    if (this.external) {
      if (this.external.$emit) {
        if (asAction) {
          this.external.$emit(name, value);
        } else {
          this.external.$emit('update', name, value);
        }
      } else {
        if (asAction) {
          this.external[name](value);
        } else {
          this.external[name] = value;
        }
      }
    }
  }

  setExternal(external) {
    this.external = external;
  }

  async loadEngine() {
    this.addListeners();
    this.cortona.app.configureInstance(this.drawing.features);
    await this.cortona.use('core', this.cortona.expand({}, this.config, this.drawing));
    await this.cortona.use('touch');
    await this.cortona.use('drawing');
    // await this.cortona.use("skin", {baseUrl: '.'})
    await this.cortona.app.initialize(this.drawing.element, this.config.src);
    this.cortona.app.recursiveObjectLookup = false;
    if (this.afterEngineLoad) {
      this.afterEngineLoad();
    }
  }

  logAllEvents() {
    let possibleEvents = [
      'app.didAttachDocument',
      'app.didCallContextMenu',
      'app.didClickHyperlink',
      'app.didFailLoadDocument',
      'app.didFinishLoadDocument',
      'app.drawing.didCallContextMenu',
      'app.drawing.didChangeScale',
      'app.drawing.didEnterHotspot',
      'app.drawing.didFailLoadDrawing',
      'app.drawing.didFinishLoadDrawing',
      'app.drawing.didHoverHotspot',
      'app.drawing.didLeaveHotspot',
      'app.drawing.didSelectHotspot',
      'app.drawing.didStartLoadDrawing',
      'app.firstFrameDidArrive',
      'app.ipc.didChangeItemVisibility',
      'app.ipc.willStartSheetTransitionAnimation',
      'app.ipc.didStopSheetTransitionAnimation',
      'app.ipc.didDrawingDisplayMode',
      'app.ipc.didHoverItem',
      'app.ipc.didSelectItem',
      'app.ipc.didSelectSheet',
      'app.ipc.dpl.didCallContextMenu',
      'app.ipc.dpl.didHoverRow',
      'app.ipc.dpl.didSelectRow',
      'app.ipc.dpl.didSetupRow',
      'app.ipc.dpl.didSetupTable',
      'app.ipc.dpl.willSetupTable',
      'app.onProgress',
      'app.onReady',
      'app.procedure.didChangePlayerState',
      'app.procedure.didEnterSubstep',
      'app.procedure.didEnterSubstepWithName',
      'app.procedure.didFireEvent',
      'app.willStartNavigateInScene',
      'core.didChangeLayout',
      //"core.didDrawAnimationFrame",
      'core.onError',
      'core.onLoad',
      'core.onRuntimeInitialized',
      'touch.didObjectClick',
      'touch.didObjectEnter',
      // "touch.didObjectMove",
      'touch.didObjectOut',
      'touch.didPointerDown',
      // "touch.didPointerEnter",
      // "touch.didPointerMove",
      // "touch.didPointerOut",
      // "touch.didPointerUp",
    ];
    possibleEvents.forEach(event => {
      this.cortona.on(event, function () {
        // const args = Array.prototype.slice.call(arguments);
        // console.log(event + '(' + args.join(', ') + ')');
      });
    });
  }
}
